import { maxTime } from 'date-fns/constants';

export const getMaxPossibleDate = (): Date => new Date(maxTime);
